//
// Xtwitter
//

const language = document.documentElement.lang;

let shareText = 'Share on X';

// translations
if (language === 'de' || language === 'de-de') {
    shareText = 'Auf X teilen';
}
// aria label
setTimeout(function() { // wihtout timeout element is not visible / created by shariff
    const twitterElementsLink = document.querySelectorAll('.shariff-button.twitter a');

    if (typeof (twitterElementsLink) != 'undefined' && twitterElementsLink != null) {
        twitterElementsLink.forEach(function(element) {
            element.setAttribute('aria-label', shareText);
            element.setAttribute('title', shareText);
        });

    }
}, 500);

export default {};